import Vue from 'vue';
import ElementUI from 'element-ui';
import MuseUI from 'muse-ui';
import VueYoutube from 'vue-youtube'

import VueClipboard from 'vue-clipboard2';
// import 'muse-ui/dist/muse-ui.css';
import axios from 'axios';
import VueAxios from 'vue-axios'
import VueI18n from 'vue-i18n';
import FlashMessage from '@smartweb/vue-flash-message';
import JsBarcode from 'jsbarcode';
import App from './App.vue'
import router from './router';
import store from './store';
import './assets/application.js';
import Ch from './assets/translate/Ch';
import En from './assets/translate/En';

import * as VueGoogleMaps from 'vue2-google-maps';

Vue.config.productionTip = false;

Vue.use(MuseUI);
Vue.use(ElementUI);
Vue.use(VueYoutube);


Vue.use(VueI18n);
Vue.use(JsBarcode);
Vue.use(VueAxios, axios);
Vue.use(VueClipboard);
Vue.use(FlashMessage);
// 使用地圖
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCNtpQAXt_GZAzMOiQ7ZvPmejKmZfmeYJo',
  },
})


const i18n = new VueI18n({
  locale: 'zh',
  messages: {
    zh: Ch,
    en: En,
  },
});

new Vue({
  render: h => h(App),
  router,
  i18n,
  store,
}).$mount('#app')
